import {NavigationMenuInlineAddType} from "../../../menu-add-with-popover/@types"
import {ViewType} from "../../../../../../core/gd/const/views/view-type"
import {ProjectSystemType} from "../../../../../../core/model2/project/types"

type Params = {
    systemType  : ProjectSystemType
    viewType    : ViewType
    projectIcon : string
}

export const ProductivityType_ParamsMap: {[key: string]: Params} = {
    [NavigationMenuInlineAddType.TODOS]         : {
        systemType  : ProjectSystemType.SINGLE_VIEW_TODOS,
        viewType    : ViewType.PROJECT_TODOS,
        projectIcon : 'todo-list'
    },
    [NavigationMenuInlineAddType.GOALS]         : {
        systemType  : ProjectSystemType.SINGLE_VIEW_GOALS,
        viewType    : ViewType.PROJECT_GOALS,
        projectIcon : 'goals'
    },
    [NavigationMenuInlineAddType.FILES]         : {
        systemType  : ProjectSystemType.SINGLE_VIEW_FILES,
        viewType    : ViewType.PROJECT_FILES,
        projectIcon : 'files'
    },
    [NavigationMenuInlineAddType.MEETINGS]      : {
        systemType  : ProjectSystemType.SINGLE_VIEW_MEETINGS,
        viewType    : ViewType.PROJECT_MEETINGS,
        projectIcon : 'meetings'
    },
    [NavigationMenuInlineAddType.EXPENSES]      : {
        systemType  : ProjectSystemType.SINGLE_VIEW_EXPENSES,
        viewType    : ViewType.PROJECT_EXPENSES,
        projectIcon : 'expenses'
    },
    [NavigationMenuInlineAddType.CHATS]         : {
        systemType  : ProjectSystemType.SINGLE_VIEW_CHATS,
        viewType    : ViewType.PROJECT_DISCUSSION,
        projectIcon : 'discussions'
    },
    [NavigationMenuInlineAddType.TASK_LIST]     : {
        systemType  : ProjectSystemType.SINGLE_VIEW_TASK_LIST,
        viewType    : ViewType.PROJECT_LIST,
        projectIcon : 'tasks'
    },
    [NavigationMenuInlineAddType.TASK_BOARD]    : {
        systemType  : ProjectSystemType.SINGLE_VIEW_TASK_BOARD,
        viewType    : ViewType.PROJECT_BOARD,
        projectIcon : 'board'
    },
}
